import { render, staticRenderFns } from "./ButtonRoleModal.vue?vue&type=template&id=02aaa9ea&scoped=true&"
import script from "./ButtonRoleModal.vue?vue&type=script&lang=js&"
export * from "./ButtonRoleModal.vue?vue&type=script&lang=js&"
import style0 from "./ButtonRoleModal.vue?vue&type=style&index=0&id=02aaa9ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02aaa9ea",
  null
  
)

export default component.exports